module.exports = "\r\n.title-one {\r\n    font-size: 20px;\r\n    padding: 0px 10px;\r\n    margin-top: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-form/emp-basic-details-form.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-form/emp-basic-details-form.component.css
// module chunks = main